import type { PublicSlotKey } from '@/apilib';
import type { SectionsMigrationPublicApi } from './api';

export const SectionsMigrationApiKey: PublicSlotKey<SectionsMigrationPublicApi> =
  {
    name: 'SectionsMigrationApi',
    public: true,
  };
